const Tabs = {
    dom: null,
    currentIndex: 0,
    autoSwitchInterval: null,

    activateTab(pos) {
        for (const [index, content] of Tabs.contents.entries()) {
            if (index === pos) {
                content.classList.remove("inactive");
                content.classList.add("active");
            } else {
                content.classList.remove("active");
                content.classList.add("inactive");
            }
        }

        for (const [index, tab] of Tabs.items.entries()) {
            if (index === pos) {
                tab.classList.add("active");
            } else {
                tab.classList.remove("active");
            }
        }

        Tabs.currentIndex = pos;
    },

    startAutoSwitch() {
        Tabs.dom.classList.add("Tabs--loop");
        Tabs.autoSwitchInterval = setInterval(() => {
            let nextIndex = (Tabs.currentIndex + 1) % Tabs.contents.length;
            Tabs.activateTab(nextIndex);
        }, 10000); // Cambia cada 10 segundos
    },

    stopAutoSwitch() {
        clearInterval(Tabs.autoSwitchInterval);
        Tabs.dom.classList.remove("Tabs--loop");
    },

    init() {
        Tabs.dom = document.querySelector('.Tabs');

        if (Tabs.dom) {
            Tabs.contents = Tabs.dom.querySelectorAll('.Tabs__content');
            Tabs.items = Tabs.dom.querySelectorAll('.Tabs__item');

            for (const [index, tab] of Tabs.items.entries()) {
                tab.addEventListener("click", (event) => {
                    event.preventDefault();
                    Tabs.activateTab(index);
                    Tabs.stopAutoSwitch();
                });
            }

            for (const content of Tabs.contents) {
                content.classList.add("inactive");
            }

            Tabs.contents[0].classList.remove("inactive");
            Tabs.contents[0].classList.add("active");
            Tabs.items[0].classList.add("active");

            Tabs.startAutoSwitch();
        }
    }
};

export default Tabs;